module.exports = __webpack_public_path__ + "img/Proto-Thema.e92fe6ad.png";